export default "__VITE_ASSET__DTnvDfpQ__"